/**
 * @module M/control/PointStyle
 */
import Draggabilly from 'draggabilly';
import PointStyleImpl from 'impl/pointStyle';
import template from 'templates/stylepoint';
import ImageCircle from '../assets/css/images/puntoSize.png';

import AgriculturaCarretilla from '../assets/css/images/svg/agricultura-carretilla.svg';
import AgriculturaCosecha from '../assets/css/images/svg/agricultura-cosecha.svg';
import AgriculturaGranero from '../assets/css/images/svg/agricultura-granero.svg';
import AgriculturaHorca from '../assets/css/images/svg/agricultura-horca.svg';
import AgriculturaHoz from '../assets/css/images/svg/agricultura-hoz.svg';
import AgriculturaLeche from '../assets/css/images/svg/agricultura-leche.svg';
import AgriculturaPanal from '../assets/css/images/svg/agricultura-panal-abejas.svg';
import AgriculturaPlantacion from '../assets/css/images/svg/agricultura-plantacion.svg';
import AgriculturaRiego from '../assets/css/images/svg/agricultura-riego.svg';
import AgriculturaTractor from '../assets/css/images/svg/agricultura-tractor.svg';
import AgriculturaVeleta from '../assets/css/images/svg/agricultura-veleta.svg';
import ComunicacionesAntena from '../assets/css/images/svg/comunicaciones-antena.svg';
import ComunicacionesDatos from '../assets/css/images/svg/comunicaciones-datos.svg';
import ComunicacionesDisco from '../assets/css/images/svg/comunicaciones-disco.svg';
import ComunicacionesDispositivos from '../assets/css/images/svg/comunicaciones-dispositivos.svg';
import ComunicacionesMicro from '../assets/css/images/svg/comunicaciones-micro.svg';
import ComunicacionesRadio from '../assets/css/images/svg/comunicaciones-radio.svg';
import ComunicacionesRuter from '../assets/css/images/svg/comunicaciones-ruter.svg';
import ComunicacionesSatelite from '../assets/css/images/svg/comunicaciones-satelite.svg';
import ComunicacionesServidor from '../assets/css/images/svg/comunicaciones-servidor.svg';
import ComunicacionesTactil from '../assets/css/images/svg/comunicaciones-tactil.svg';
import ComunicacionesTelefono from '../assets/css/images/svg/comunicaciones-telefono.svg';
import ComunicacionesTv from '../assets/css/images/svg/comunicaciones-tv.svg';
import DeportesArco from '../assets/css/images/svg/deportes-arco.svg';
import DeportesBadminton from '../assets/css/images/svg/deportes-badminton.svg';
import DeportesBaloncesto from '../assets/css/images/svg/deportes-baloncesto.svg';
import DeportesEscalada from '../assets/css/images/svg/deportes-escalada.svg';
import DeportesFutbolAmericano from '../assets/css/images/svg/deportes-futbol-americano.svg';
import DeportesFutbol from '../assets/css/images/svg/deportes-futbol.svg';
import DeportesKayak from '../assets/css/images/svg/deportes-kayak.svg';
import DeportesPing from '../assets/css/images/svg/deportes-ping-pong.svg';
import DeportesSnowboard from '../assets/css/images/svg/deportes-snowboard.svg';
import DeportesSurf from '../assets/css/images/svg/deportes-surf.svg';
import DeportesTiro from '../assets/css/images/svg/deportes-tiro.svg';
import DeportesVoleibol from '../assets/css/images/svg/deportes-voleibol.svg';
import EdificiosAlmacen from '../assets/css/images/svg/edificios-almacen.svg';
import EdificiosCasa from '../assets/css/images/svg/edificios-casa.svg';
import EdificiosEstadio from '../assets/css/images/svg/edificios-estadio.svg';
import EdificiosFabrica from '../assets/css/images/svg/edificios-fabrica.svg';
import EdificiosFaro from '../assets/css/images/svg/edificios-faro.svg';
import EdificiosGasolinera from '../assets/css/images/svg/edificios-gasolinera.svg';
import EdificiosGranja from '../assets/css/images/svg/edificios-granja.svg';
import EdificiosHospital from '../assets/css/images/svg/edificios-hospital.svg';
import EdificiosHotel from '../assets/css/images/svg/edificios-hotel.svg';
import EdificiosIglesia from '../assets/css/images/svg/edificios-iglesia.svg';
import EdificiosLavacoches from '../assets/css/images/svg/edificios-lavacoches.svg';
import EdificiosTienda from '../assets/css/images/svg/edificios-tienda.svg';
import EdificiosUniversidad from '../assets/css/images/svg/edificios-universidad.svg';
import EducacionAtomo from '../assets/css/images/svg/educacion-atomo.svg';
import EducacionBirrete from '../assets/css/images/svg/educacion-birrete.svg';
import EducacionCalculadora from '../assets/css/images/svg/educacion-calculadora.svg';
import EducacionClip from '../assets/css/images/svg/educacion-clip.svg';
import EducacionCompass from '../assets/css/images/svg/educacion-compass.svg';
import EducacionCuaderno from '../assets/css/images/svg/educacion-cuaderno.svg';
import EducacionLapicero from '../assets/css/images/svg/educacion-lapicero.svg';
import EducacionLibro from '../assets/css/images/svg/educacion-libro.svg';
import EducacionMicroscopio from '../assets/css/images/svg/educacion-microscopio.svg';
import EducacionPin from '../assets/css/images/svg/educacion-pin.svg';
import EducacionPizarra from '../assets/css/images/svg/educacion-pizarra.svg';
import EducacionQuimica from '../assets/css/images/svg/educacion-quimica.svg';
import EducacionRegla from '../assets/css/images/svg/educacion-regla.svg';
import EducacionTelescopio from '../assets/css/images/svg/educacion-telescopio.svg';
import EducacionTijeras from '../assets/css/images/svg/educacion-tijeras.svg';
import EducacionTribuna from '../assets/css/images/svg/educacion-tribuna.svg';
import EnergiaBateria from '../assets/css/images/svg/energia-bateria.svg';
import EnergiaEstacion from '../assets/css/images/svg/energia-estacion-carga.svg';
import EnergiaMolino from '../assets/css/images/svg/energia-molino-viento.svg';
import EnergiaPanel from '../assets/css/images/svg/energia-panel-solar.svg';
import EnergiaPoste from '../assets/css/images/svg/energia-poste.svg';
import GeneralAjustes from '../assets/css/images/svg/general-ajustes.svg';
import GeneralAlerta from '../assets/css/images/svg/general-alerta.svg';
import GeneralArroba from '../assets/css/images/svg/general-arroba.svg';
import GeneralAyuda from '../assets/css/images/svg/general-ayuda.svg';
import GeneralCancelar from '../assets/css/images/svg/general-cancelar.svg';
import GeneralCirculo from '../assets/css/images/svg/general-circulo.svg';
import GeneralConfig from '../assets/css/images/svg/general-config.svg';
import GeneralCono from '../assets/css/images/svg/general-cono.svg';
import GeneralCorazon from '../assets/css/images/svg/general-corazon.svg';
import GeneralCronometro from '../assets/css/images/svg/general-cronometro.svg';
import GeneralCuadrado from '../assets/css/images/svg/general-cuadrado.svg';
import GeneralCubo from '../assets/css/images/svg/general-cubo.svg';
import GeneralDescargar from '../assets/css/images/svg/general-descargar.svg';
import GeneralFuente from '../assets/css/images/svg/general-fuente.svg';
import GeneralInfo from '../assets/css/images/svg/general-info.svg';
import GeneralLinea from '../assets/css/images/svg/general-linea.svg';
import GeneralLink from '../assets/css/images/svg/general-link.svg';
import GeneralMas from '../assets/css/images/svg/general-mas.svg';
import GeneralMenos from '../assets/css/images/svg/general-menos.svg';
import GeneralMenu from '../assets/css/images/svg/general-menu.svg';
import GeneralNube from '../assets/css/images/svg/general-nube.svg';
import GeneralParaguas from '../assets/css/images/svg/general-paraguas.svg';
import GeneralPin from '../assets/css/images/svg/general-pin.svg';
import GeneralPoligono from '../assets/css/images/svg/general-poligono.svg';
import GeneralPuntos from '../assets/css/images/svg/general-puntos.svg';
import GeneralRombo from '../assets/css/images/svg/general-rombo.svg';
import GeneralTriangulo from '../assets/css/images/svg/general-triangulo.svg';
import MonumentoCastillo from '../assets/css/images/svg/monumento-castillo.svg';
import MonumentoCatedral from '../assets/css/images/svg/monumento-catedral.svg';
import MonumentoChina from '../assets/css/images/svg/monumento-china.svg';
import MonumentoColiseo from '../assets/css/images/svg/monumento-coliseo.svg';
import MonumentoColumna from '../assets/css/images/svg/monumento-columna.svg';
import MonumentoDisneyland from '../assets/css/images/svg/monumento-disneyland.svg';
import MonumentoEsfinge from '../assets/css/images/svg/monumento-esfinge.svg';
import MonumentoEstatua from '../assets/css/images/svg/monumento-estatua.svg';
import MonumentoFamilia from '../assets/css/images/svg/monumento-familia.svg';
import MonumentoGobierno from '../assets/css/images/svg/monumento-gobierno.svg';
import MonumentoIndia from '../assets/css/images/svg/monumento-india.svg';
import MonumentoIslam from '../assets/css/images/svg/monumento-islam.svg';
import MonumentoLibertad from '../assets/css/images/svg/monumento-libertad.svg';
import MonumentoMadrid from '../assets/css/images/svg/monumento-madrid.svg';
import MonumentoMedieval from '../assets/css/images/svg/monumento-medieval.svg';
import MonumentoMolino from '../assets/css/images/svg/monumento-molino.svg';
import MonumentoObelisco from '../assets/css/images/svg/monumento-obelisco.svg';
import MonumentoOriental from '../assets/css/images/svg/monumento-oriental.svg';
import MonumentoParis from '../assets/css/images/svg/monumento-paris.svg';
import MonumentoPisa from '../assets/css/images/svg/monumento-pisa.svg';
import MonumentoPuente from '../assets/css/images/svg/monumento-puente.svg';
import MonumentoStonehenge from '../assets/css/images/svg/monumento-stonehenge.svg';
import MonumentoTemplo from '../assets/css/images/svg/monumento-templo.svg';
import MonumentoTorre from '../assets/css/images/svg/monumento-torre.svg';
import NaturalezaArboles from '../assets/css/images/svg/naturaleza-arboles.svg';
import NaturalezaArbol from '../assets/css/images/svg/naturaleza-arbol.svg';
import NaturalezaBallena from '../assets/css/images/svg/naturaleza-ballena.svg';
import NaturalezaBrote from '../assets/css/images/svg/naturaleza-brote.svg';
import NaturalezaCactus from '../assets/css/images/svg/naturaleza-cactus.svg';
import NaturalezaConejo from '../assets/css/images/svg/naturaleza-conejo.svg';
import NaturalezaDelfin from '../assets/css/images/svg/naturaleza-delfin.svg';
import NaturalezaFlor from '../assets/css/images/svg/naturaleza-flor.svg';
import NaturalezaGallo from '../assets/css/images/svg/naturaleza-gallo.svg';
import NaturalezaHierba from '../assets/css/images/svg/naturaleza-hierba.svg';
import NaturalezaHoja from '../assets/css/images/svg/naturaleza-hoja.svg';
import NaturalezaHoja2 from '../assets/css/images/svg/naturaleza-hoja2.svg';
import NaturalezaHojas from '../assets/css/images/svg/naturaleza-hojas.svg';
import NaturalezaInsecto from '../assets/css/images/svg/naturaleza-insecto.svg';
import NaturalezaJuncos from '../assets/css/images/svg/naturaleza-juncos.svg';
import NaturalezaLirio from '../assets/css/images/svg/naturaleza-lirio-agua.svg';
import NaturalezaLuna from '../assets/css/images/svg/naturaleza-luna.svg';
import NaturalezaMedusa from '../assets/css/images/svg/naturaleza-medusa.svg';
import NaturalezaNubes from '../assets/css/images/svg/naturaleza-nubes.svg';
import NaturalezaOlas from '../assets/css/images/svg/naturaleza-olas.svg';
import NaturalezaOveja from '../assets/css/images/svg/naturaleza-oveja.svg';
import NaturalezaPalmera from '../assets/css/images/svg/naturaleza-palmera.svg';
import NaturalezaParque from '../assets/css/images/svg/naturaleza-parque.svg';
import NaturalezaPato from '../assets/css/images/svg/naturaleza-pato.svg';
import NaturalezaPez from '../assets/css/images/svg/naturaleza-pez.svg';
import NaturalezaPlanta2 from '../assets/css/images/svg/naturaleza-planta2.svg';
import NaturalezaPlanta from '../assets/css/images/svg/naturaleza-planta.svg';
import NaturalezaRama from '../assets/css/images/svg/naturaleza-rama.svg';
import NaturalezArbol from '../assets/css/images/svg/naturalez-arbol.svg';
import NaturalezaSol from '../assets/css/images/svg/naturaleza-sol.svg';
import NaturalezaTortuga from '../assets/css/images/svg/naturaleza-tortuga.svg';
import NaturalezaViento from '../assets/css/images/svg/naturaleza-viento.svg';
import NaturalezPajaro from '../assets/css/images/svg/naturalez-pajaro.svg';
import NaturalezRio from '../assets/css/images/svg/naturalez-rio.svg';
import OcioAjedrez from '../assets/css/images/svg/ocio-ajedrez.svg';
import OcioBarbacoa from '../assets/css/images/svg/ocio-barbacoa.svg';
import OcioCafeteria from '../assets/css/images/svg/ocio-cafeteria.svg';
import OcioCine from '../assets/css/images/svg/ocio-cine.svg';
import OcioCocktail from '../assets/css/images/svg/ocio-cocktail.svg';
import OcioCompras from '../assets/css/images/svg/ocio-compras.svg';
import OcioEspectaculo from '../assets/css/images/svg/ocio-espectaculo.svg';
import OcioFeria from '../assets/css/images/svg/ocio-feria.svg';
import OcioFotografia from '../assets/css/images/svg/ocio-fotografia.svg';
import OcioGimnasio from '../assets/css/images/svg/ocio-gimnasio.svg';
import OcioGlobo from '../assets/css/images/svg/ocio-globo.svg';
import OcioGuitarra from '../assets/css/images/svg/ocio-guitarra.svg';
import OcioHelados from '../assets/css/images/svg/ocio-helados.svg';
import OcioNatacion from '../assets/css/images/svg/ocio-natacion.svg';
import OcioPasteleria from '../assets/css/images/svg/ocio-pasteleria.svg';
import OcioPesca from '../assets/css/images/svg/ocio-pesca.svg';
import OcioPintura from '../assets/css/images/svg/ocio-pintura.svg';
import OcioPiscina from '../assets/css/images/svg/ocio-piscina.svg';
import OcioRegalo from '../assets/css/images/svg/ocio-regalo.svg';
import OcioRestaurante from '../assets/css/images/svg/ocio-restaurante.svg';
import OcioSenderismo from '../assets/css/images/svg/ocio-senderismo.svg';
import OcioSpa from '../assets/css/images/svg/ocio-spa.svg';
import OcioSubmarinismo from '../assets/css/images/svg/ocio-submarinismo.svg';
import OcioYoga from '../assets/css/images/svg/ocio-yoga.svg';
import ProfesionesBombero from '../assets/css/images/svg/profesiones-bombero.svg';
import ProfesionesCamarero from '../assets/css/images/svg/profesiones-camarero.svg';
import ProfesionesCarnicero from '../assets/css/images/svg/profesiones-carnicero.svg';
import ProfesionesCarpintero from '../assets/css/images/svg/profesiones-carpintero.svg';
import ProfesionesConductor from '../assets/css/images/svg/profesiones-conductor.svg';
import ProfesionesDentista from '../assets/css/images/svg/profesiones-dentista.svg';
import ProfesionesDoctor from '../assets/css/images/svg/profesiones-doctor.svg';
import ProfesionesEnfermero from '../assets/css/images/svg/profesiones-enfermero.svg';
import ProfesionesGranjero from '../assets/css/images/svg/profesiones-granjero.svg';
import ProfesionesJardinero from '../assets/css/images/svg/profesiones-jardinero.svg';
import ProfesionesMecanico from '../assets/css/images/svg/profesiones-mecanico.svg';
import ProfesionesMinero from '../assets/css/images/svg/profesiones-minero.svg';
import ProfesionesObrero from '../assets/css/images/svg/profesiones-obrero.svg';
import ProfesionesOficinista from '../assets/css/images/svg/profesiones-oficinista.svg';
import ProfesionesPeluqueria from '../assets/css/images/svg/profesiones-peluqueria.svg';
import ProfesionesPintor2 from '../assets/css/images/svg/profesiones-pintor2.svg';
import ProfesionesPintor from '../assets/css/images/svg/profesiones-pintor.svg';
import ProfesionesPolicia from '../assets/css/images/svg/profesiones-policia.svg';
import ProfesionesSoporte from '../assets/css/images/svg/profesiones-soporte.svg';
import SaludAlcohol from '../assets/css/images/svg/salud-alcohol.svg';
import SaludHigiene from '../assets/css/images/svg/salud-higiene.svg';
import SaludHistorial from '../assets/css/images/svg/salud-historial.svg';
import SaludInyeccion from '../assets/css/images/svg/salud-inyeccion.svg';
import SaludLavadora from '../assets/css/images/svg/salud-lavadora.svg';
import SaludMaletin from '../assets/css/images/svg/salud-maletin.svg';
import SaludMascarilla from '../assets/css/images/svg/salud-mascarilla.svg';
import SaludMedicamentos from '../assets/css/images/svg/salud-medicamentos.svg';
import SaludMicroscopio from '../assets/css/images/svg/salud-microscopio.svg';
import SaludPapel from '../assets/css/images/svg/salud-papel-higienico.svg';
import SaludPauelos from '../assets/css/images/svg/salud-pauelos.svg';
import SaludPulsaciones from '../assets/css/images/svg/salud-pulsaciones.svg';
import SaludReceta from '../assets/css/images/svg/salud-receta.svg';
import SaludSilla from '../assets/css/images/svg/salud-silla-ruedas.svg';
import SaludTermometro from '../assets/css/images/svg/salud-termometro.svg';
import SaludTirita from '../assets/css/images/svg/salud-tirita.svg';
import SaludVirus from '../assets/css/images/svg/salud-virus.svg';
import TransporteAmbulacia from '../assets/css/images/svg/transporte-ambulacia.svg';
import TransporteAvion from '../assets/css/images/svg/transporte-avion.svg';
import TransporteBicicleta from '../assets/css/images/svg/transporte-bicicleta.svg';
import TransporteBus from '../assets/css/images/svg/transporte-bus.svg';
import TransporteCamion from '../assets/css/images/svg/transporte-camion.svg';
import TransporteCaravana from '../assets/css/images/svg/transporte-caravana.svg';
import TransporteCoche from '../assets/css/images/svg/transporte-coche.svg';
import TransporteDemolicion from '../assets/css/images/svg/transporte-demolicion.svg';
import TransporteGrua from '../assets/css/images/svg/transporte-grua.svg';
import TransporteHelicoptero from '../assets/css/images/svg/transporte-helicoptero.svg';
import TransporteMoto from '../assets/css/images/svg/transporte-moto.svg';
import TransporteTaxi from '../assets/css/images/svg/transporte-taxi.svg';
import TransporteTrain from '../assets/css/images/svg/transporte-train.svg';
import TransporteVela from '../assets/css/images/svg/transporte-vela.svg';
import TransporteYate from '../assets/css/images/svg/transporte-yate.svg';
import TurismoArea from '../assets/css/images/svg/turismo-area-descanso.svg';
import TurismoBosque from '../assets/css/images/svg/turismo-bosque.svg';
import TurismoCamping from '../assets/css/images/svg/turismo-camping.svg';
import TurismoDesierto from '../assets/css/images/svg/turismo-desierto.svg';
import TurismoEquipaje from '../assets/css/images/svg/turismo-equipaje.svg';
import TurismoHoguera from '../assets/css/images/svg/turismo-hoguera.svg';
import TurismoMapa from '../assets/css/images/svg/turismo-mapa.svg';
import TurismoMontanya from '../assets/css/images/svg/turismo-montanya.svg';
import TurismoPlaya from '../assets/css/images/svg/turismo-playa.svg';
import TurismoRuta from '../assets/css/images/svg/turismo-ruta.svg';
import TurismoSeal from '../assets/css/images/svg/turismo-seal.svg';
import TurismoTeleferico from '../assets/css/images/svg/turismo-teleferico.svg';
import ViarioBanco from '../assets/css/images/svg/viario-banco.svg';
import ViarioBarrera from '../assets/css/images/svg/viario-barrera.svg';
import ViarioBasura from '../assets/css/images/svg/viario-basura.svg';
import ViarioCono from '../assets/css/images/svg/viario-cono.svg';
import ViarioFarola from '../assets/css/images/svg/viario-farola.svg';
import ViarioLetrero from '../assets/css/images/svg/viario-letrero.svg';
import ViarioParada from '../assets/css/images/svg/viario-parada-bus.svg';
import ViarioParking from '../assets/css/images/svg/viario-parking.svg';
import ViarioPuesto from '../assets/css/images/svg/viario-puesto.svg';
import ViarioReciclaje from '../assets/css/images/svg/viario-reciclaje.svg';
import ViarioSemaforo from '../assets/css/images/svg/viario-semaforo.svg';
import ViarioStop from '../assets/css/images/svg/viario-stop.svg';


import { getValue } from './i18n/language';

// const accents      ='&ÀÁÂÃÄÅĄĀāàáâãäåąßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËĘèéêëęðÇçČčĆćÐÌÍÎÏĪìíîïīÙÚÛÜŰùűúûüĽĹŁľĺłÑŇŃňñńŔŕŠŚŞšśşŤťŸÝÿýŽŻŹžżźđĢĞģğ';
// const accents_out  ='AAAAAAAAAaaaaaaaasOOOOOOOOoooooooDdDZdzEEEEEeeeeeeCcCcCcDIIIIIiiiiiUUUUUuuuuuLLLlllNNNnnnRrSSSsssTtYYyyZZZzzzdGGgg';
// for(let k = 0; k<accents.length;k++){ DC[accents.charCodeAt(k)] = accents_out.charCodeAt(k);}
const DC = { 38: 65, 68: 68, 100: 100, 192: 65, 193: 65, 194: 65, 195: 65, 196: 65, 197: 65, 199: 67, 200: 69, 201: 69, 202: 69, 203: 69, 204: 73, 205: 73, 206: 73, 207: 73, 208: 68, 209: 78, 210: 79, 211: 79, 212: 79, 213: 79, 214: 79, 216: 79, 217: 85, 218: 85, 219: 85, 220: 85, 221: 89, 223: 115, 224: 97, 225: 97, 226: 97, 227: 97, 228: 97, 229: 97, 231: 99, 232: 101, 233: 101, 234: 101, 235: 101, 236: 105, 237: 105, 238: 105, 239: 105, 240: 101, 241: 110, 242: 111, 243: 111, 244: 111, 245: 111, 246: 111, 248: 111, 249: 117, 250: 117, 251: 117, 252: 117, 253: 121, 255: 121, 256: 65, 257: 97, 260: 65, 261: 97, 262: 67, 263: 99, 268: 67, 269: 99, 270: 68, 271: 100, 273: 100, 280: 69, 281: 101, 286: 71, 287: 103, 290: 71, 291: 103, 298: 73, 299: 105, 313: 76, 314: 108, 317: 76, 318: 108, 321: 76, 322: 108, 323: 78, 324: 110, 327: 78, 328: 110, 336: 79, 337: 111, 340: 82, 341: 114, 346: 83, 347: 115, 350: 83, 351: 115, 352: 83, 353: 115, 356: 84, 357: 116, 368: 85, 369: 117, 376: 89, 377: 90, 378: 122, 379: 90, 380: 122, 381: 90, 382: 122 };
export default class PointStyle extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(plugin, feature) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(PointStyleImpl)) {
      M.exception('La implementación usada no puede crear controles StyleToolsControl');
    }

    // 2. implementation of this control
    const impl = new PointStyleImpl();
    super(impl, 'PointStyle');
    this.coding = 'data:image/svg+xml;base64,';
    this.plugin = plugin;
    this.features = feature;
    for (let i = 0; i < this.features.length; i += 1) {
      const feature = this.features[i];
      const auxImage = feature.getStyle().getImage();
      this.category = null;
      if (!(auxImage.fill_ === null || auxImage.fill_ === undefined)) {
        this.icon = null;
        this.color = auxImage.getFill().getColor();
      } else {
        const paso2 = feature.get('icon');
        this.icon = paso2;
        this.color = feature.get('color');
      }
      if (auxImage.radius_ != undefined && auxImage.radius_ != null) {
        // this.size = auxImage.radius_;
        this.size = feature.realStyle.image.radius;
      } else {
        this.size = feature.get('size');
      }
    }

    this.listaDeIconos = null;
    this.listaDeIconos = {
      id: 'Formas base',
      name: 'Formas base',
      icons: [],
    };

    const svgList = ['g-cartografia-circulo', 'malc-agricultura-carretilla', 'malc-agricultura-cosecha', 'malc-agricultura-granero', 'malc-agricultura-horca', 'malc-agricultura-hoz', 'malc-agricultura-leche', 'malc-agricultura-panal-abejas', 'malc-agricultura-plantacion', 'malc-agricultura-riego', 'malc-agricultura-tractor', 'malc-agricultura-veleta', 'malc-comunicaciones-antena', 'malc-comunicaciones-datos', 'malc-comunicaciones-disco', 'malc-comunicaciones-dispositivos', 'malc-comunicaciones-micro', 'malc-comunicaciones-radio', 'malc-comunicaciones-ruter', 'malc-comunicaciones-satelite', 'malc-comunicaciones-servidor', 'malc-comunicaciones-tactil', 'malc-comunicaciones-telefono', 'malc-comunicaciones-tv', 'malc-deportes-arco', 'malc-deportes-badminton', 'malc-deportes-baloncesto', 'malc-deportes-escalada', 'malc-deportes-futbol-americano', 'malc-deportes-futbol', 'malc-deportes-kayak', 'malc-deportes-ping-pong', 'malc-deportes-snowboard', 'malc-deportes-surf', 'malc-deportes-tiro', 'malc-deportes-voleibol', 'malc-edificios-almacen', 'malc-edificios-casa', 'malc-edificios-estadio', 'malc-edificios-fabrica', 'malc-edificios-faro', 'malc-edificios-gasolinera', 'malc-edificios-granja', 'malc-edificios-hospital', 'malc-edificios-hotel', 'malc-edificios-iglesia', 'malc-edificios-lavacoches', 'malc-edificios-tienda', 'malc-edificios-universidad', 'malc-educacion-atomo', 'malc-educacion-birrete', 'malc-educacion-calculadora', 'malc-educacion-clip', 'malc-educacion-compass', 'malc-educacion-cuaderno', 'malc-educacion-lapicero', 'malc-educacion-libro', 'malc-educacion-microscopio', 'malc-educacion-pin', 'malc-educacion-pizarra', 'malc-educacion-quimica', 'malc-educacion-regla', 'malc-educacion-telescopio', 'malc-educacion-tijeras', 'malc-educacion-tribuna', 'malc-energia-bateria', 'malc-energia-estacion-carga', 'malc-energia-molino-viento', 'malc-energia-panel-solar', 'malc-energia-poste', 'malc-general-ajustes', 'malc-general-alerta', 'malc-general-arroba', 'malc-general-ayuda', 'malc-general-cancelar', 'malc-general-circulo', 'malc-general-config', 'malc-general-cono', 'malc-general-corazon', 'malc-general-cronometro', 'malc-general-cuadrado', 'malc-general-cubo', 'malc-general-descargar', 'malc-general-fuente', 'malc-general-info', 'malc-general-linea', 'malc-general-link', 'malc-general-mas', 'malc-general-menos', 'malc-general-menu', 'malc-general-nube', 'malc-general-paraguas', 'malc-general-pin', 'malc-general-poligono', 'malc-general-puntos', 'malc-general-rombo', 'malc-general-triangulo', 'malc-monumento-castillo', 'malc-monumento-catedral', 'malc-monumento-china', 'malc-monumento-coliseo', 'malc-monumento-columna', 'malc-monumento-disneyland', 'malc-monumento-esfinge', 'malc-monumento-estatua', 'malc-monumento-familia', 'malc-monumento-gobierno', 'malc-monumento-india', 'malc-monumento-islam', 'malc-monumento-libertad', 'malc-monumento-madrid', 'malc-monumento-medieval', 'malc-monumento-molino', 'malc-monumento-obelisco', 'malc-monumento-oriental', 'malc-monumento-paris', 'malc-monumento-pisa', 'malc-monumento-puente', 'malc-monumento-stonehenge', 'malc-monumento-templo', 'malc-monumento-torre', 'malc-naturaleza-arbol', 'malc-naturaleza-arboles', 'malc-naturaleza-ballena', 'malc-naturaleza-brote', 'malc-naturaleza-cactus', 'malc-naturaleza-conejo', 'malc-naturaleza-delfin', 'malc-naturaleza-flor', 'malc-naturaleza-gallo', 'malc-naturaleza-hierba', 'malc-naturaleza-hoja', 'malc-naturaleza-hoja2', 'malc-naturaleza-hojas', 'malc-naturaleza-insecto', 'malc-naturaleza-juncos', 'malc-naturaleza-lirio-agua', 'malc-naturaleza-luna', 'malc-naturaleza-medusa', 'malc-naturaleza-nubes', 'malc-naturaleza-olas', 'malc-naturaleza-oveja', 'malc-naturaleza-palmera', 'malc-naturaleza-parque', 'malc-naturaleza-pato', 'malc-naturaleza-pez', 'malc-naturaleza-planta', 'malc-naturaleza-planta2', 'malc-naturaleza-rama', 'malc-naturalez-arbol', 'malc-naturaleza-sol', 'malc-naturaleza-tortuga', 'malc-naturaleza-viento', 'malc-naturalez-pajaro', 'malc-naturalez-rio', 'malc-ocio-ajedrez', 'malc-ocio-barbacoa', 'malc-ocio-cafeteria', 'malc-ocio-cine', 'malc-ocio-cocktail', 'malc-ocio-compras', 'malc-ocio-espectaculo', 'malc-ocio-feria', 'malc-ocio-fotografia', 'malc-ocio-gimnasio', 'malc-ocio-globo', 'malc-ocio-guitarra', 'malc-ocio-helados', 'malc-ocio-natacion', 'malc-ocio-pasteleria', 'malc-ocio-pesca', 'malc-ocio-pintura', 'malc-ocio-piscina', 'malc-ocio-regalo', 'malc-ocio-restaurante', 'malc-ocio-senderismo', 'malc-ocio-spa', 'malc-ocio-submarinismo', 'malc-ocio-yoga', 'malc-profesiones-bombero', 'malc-profesiones-camarero', 'malc-profesiones-carnicero', 'malc-profesiones-carpintero', 'malc-profesiones-conductor', 'malc-profesiones-dentista', 'malc-profesiones-doctor', 'malc-profesiones-enfermero', 'malc-profesiones-granjero', 'malc-profesiones-jardinero', 'malc-profesiones-mecanico', 'malc-profesiones-minero', 'malc-profesiones-obrero', 'malc-profesiones-oficinista', 'malc-profesiones-peluqueria', 'malc-profesiones-pintor', 'malc-profesiones-pintor2', 'malc-profesiones-policia', 'malc-profesiones-soporte', 'malc-salud-alcohol', 'malc-salud-higiene', 'malc-salud-historial', 'malc-salud-inyeccion', 'malc-salud-lavadora', 'malc-salud-maletin', 'malc-salud-mascarilla', 'malc-salud-medicamentos', 'malc-salud-microscopio', 'malc-salud-pauelos', 'malc-salud-papel-higienico', 'malc-salud-pulsaciones', 'malc-salud-receta', 'malc-salud-silla-ruedas', 'malc-salud-termometro', 'malc-salud-tirita', 'malc-salud-virus', 'malc-transporte-ambulacia', 'malc-transporte-avion', 'malc-transporte-bicicleta', 'malc-transporte-bus', 'malc-transporte-camion', 'malc-transporte-caravana', 'malc-transporte-coche', 'malc-transporte-demolicion', 'malc-transporte-grua', 'malc-transporte-helicoptero', 'malc-transporte-moto', 'malc-transporte-taxi', 'malc-transporte-train', 'malc-transporte-vela', 'malc-transporte-yate', 'malc-turismo-area-descanso', 'malc-turismo-bosque', 'malc-turismo-camping', 'malc-turismo-desierto', 'malc-turismo-equipaje', 'malc-turismo-hoguera', 'malc-turismo-mapa', 'malc-turismo-montanya', 'malc-turismo-playa', 'malc-turismo-ruta', 'malc-turismo-seal', 'malc-turismo-teleferico', 'malc-viario-banco', 'malc-viario-barrera', 'malc-viario-basura', 'malc-viario-cono', 'malc-viario-farola', 'malc-viario-letrero', 'malc-viario-parada-bus', 'malc-viario-parking', 'malc-viario-puesto', 'malc-viario-reciclaje', 'malc-viario-semaforo', 'malc-viario-stop'];
    const classIconList = ['CirculoSVG', AgriculturaCarretilla, AgriculturaCosecha, AgriculturaGranero, AgriculturaHorca, AgriculturaHoz, AgriculturaLeche, AgriculturaPanal, AgriculturaPlantacion, AgriculturaRiego, AgriculturaTractor, AgriculturaVeleta, ComunicacionesAntena, ComunicacionesDatos, ComunicacionesDisco, ComunicacionesDispositivos, ComunicacionesMicro, ComunicacionesRadio, ComunicacionesRuter, ComunicacionesSatelite, ComunicacionesServidor, ComunicacionesTactil, ComunicacionesTelefono, ComunicacionesTv, DeportesArco, DeportesBadminton, DeportesBaloncesto, DeportesEscalada, DeportesFutbolAmericano, DeportesFutbol, DeportesKayak, DeportesPing, DeportesSnowboard, DeportesSurf, DeportesTiro, DeportesVoleibol, EdificiosAlmacen, EdificiosCasa, EdificiosEstadio, EdificiosFabrica, EdificiosFaro, EdificiosGasolinera, EdificiosGranja, EdificiosHospital, EdificiosHotel, EdificiosIglesia, EdificiosLavacoches, EdificiosTienda, EdificiosUniversidad, EducacionAtomo, EducacionBirrete, EducacionCalculadora, EducacionClip, EducacionCompass, EducacionCuaderno, EducacionLapicero, EducacionLibro, EducacionMicroscopio, EducacionPin, EducacionPizarra, EducacionQuimica, EducacionRegla, EducacionTelescopio, EducacionTijeras, EducacionTribuna, EnergiaBateria, EnergiaEstacion, EnergiaMolino, EnergiaPanel, EnergiaPoste, GeneralAjustes, GeneralAlerta, GeneralArroba, GeneralAyuda, GeneralCancelar, GeneralCirculo, GeneralConfig, GeneralCono, GeneralCorazon, GeneralCronometro, GeneralCuadrado, GeneralCubo, GeneralDescargar, GeneralFuente, GeneralInfo, GeneralLinea, GeneralLink, GeneralMas, GeneralMenos, GeneralMenu, GeneralNube, GeneralParaguas, GeneralPin, GeneralPoligono, GeneralPuntos, GeneralRombo, GeneralTriangulo, MonumentoCastillo, MonumentoCatedral, MonumentoChina, MonumentoColiseo, MonumentoColumna, MonumentoDisneyland, MonumentoEsfinge, MonumentoEstatua, MonumentoFamilia, MonumentoGobierno, MonumentoIndia, MonumentoIslam, MonumentoLibertad, MonumentoMadrid, MonumentoMedieval, MonumentoMolino, MonumentoObelisco, MonumentoOriental, MonumentoParis, MonumentoPisa, MonumentoPuente, MonumentoStonehenge, MonumentoTemplo, MonumentoTorre, NaturalezaArboles, NaturalezaArbol, NaturalezaBallena, NaturalezaBrote, NaturalezaCactus, NaturalezaConejo, NaturalezaDelfin, NaturalezaFlor, NaturalezaGallo, NaturalezaHierba, NaturalezaHoja, NaturalezaHoja2, NaturalezaHojas, NaturalezaInsecto, NaturalezaJuncos, NaturalezaLirio, NaturalezaLuna, NaturalezaMedusa, NaturalezaNubes, NaturalezaOlas, NaturalezaOveja, NaturalezaPalmera, NaturalezaParque, NaturalezaPato, NaturalezaPez, NaturalezaPlanta2, NaturalezaPlanta, NaturalezaRama, NaturalezArbol, NaturalezaSol, NaturalezaTortuga, NaturalezaViento, NaturalezPajaro, NaturalezRio, OcioAjedrez, OcioBarbacoa, OcioCafeteria, OcioCine, OcioCocktail, OcioCompras, OcioEspectaculo, OcioFeria, OcioFotografia, OcioGimnasio, OcioGlobo, OcioGuitarra, OcioHelados, OcioNatacion, OcioPasteleria, OcioPesca, OcioPintura, OcioPiscina, OcioRegalo, OcioRestaurante, OcioSenderismo, OcioSpa, OcioSubmarinismo, OcioYoga, ProfesionesBombero, ProfesionesCamarero, ProfesionesCarnicero, ProfesionesCarpintero, ProfesionesConductor, ProfesionesDentista, ProfesionesDoctor, ProfesionesEnfermero, ProfesionesGranjero, ProfesionesJardinero, ProfesionesMecanico, ProfesionesMinero, ProfesionesObrero, ProfesionesOficinista, ProfesionesPeluqueria, ProfesionesPintor2, ProfesionesPintor, ProfesionesPolicia, ProfesionesSoporte, SaludAlcohol, SaludHigiene, SaludHistorial, SaludInyeccion, SaludLavadora, SaludMaletin, SaludMascarilla, SaludMedicamentos, SaludMicroscopio, SaludPapel, SaludPauelos, SaludPulsaciones, SaludReceta, SaludSilla, SaludTermometro, SaludTirita, SaludVirus, TransporteAmbulacia, TransporteAvion, TransporteBicicleta, TransporteBus, TransporteCamion, TransporteCaravana, TransporteCoche, TransporteDemolicion, TransporteGrua, TransporteHelicoptero, TransporteMoto, TransporteTaxi, TransporteTrain, TransporteVela, TransporteYate, TurismoArea, TurismoBosque, TurismoCamping, TurismoDesierto, TurismoEquipaje, TurismoHoguera, TurismoMapa, TurismoMontanya, TurismoPlaya, TurismoRuta, TurismoSeal, TurismoTeleferico, ViarioBanco, ViarioBarrera, ViarioBasura, ViarioCono, ViarioFarola, ViarioLetrero, ViarioParada, ViarioParking, ViarioPuesto, ViarioReciclaje, ViarioSemaforo, ViarioStop];
    const sourceList = ['CirculoSVG', 'agricultura-carretilla.svg', 'agricultura-cosecha.svg', 'agricultura-granero.svg', 'agricultura-horca.svg', 'agricultura-hoz.svg', 'agricultura-leche.svg', 'agricultura-panal-abejas.svg', 'agricultura-plantacion.svg', 'agricultura-riego.svg', 'agricultura-tractor.svg', 'agricultura-veleta.svg', 'comunicaciones-antena.svg', 'comunicaciones-datos.svg', 'comunicaciones-disco.svg', 'comunicaciones-dispositivos.svg', 'comunicaciones-micro.svg', 'comunicaciones-radio.svg', 'comunicaciones-ruter.svg', 'comunicaciones-satelite.svg', 'comunicaciones-servidor.svg', 'comunicaciones-tactil.svg', 'comunicaciones-telefono.svg', 'comunicaciones-tv.svg', 'deportes-arco.svg', 'deportes-badminton.svg', 'deportes-baloncesto.svg', 'deportes-escalada.svg', 'deportes-futbol-americano.svg', 'deportes-futbol.svg', 'deportes-kayak.svg', 'deportes-ping-pong.svg', 'deportes-snowboard.svg', 'deportes-surf.svg', 'deportes-tiro.svg', 'deportes-voleibol.svg', 'edificios-almacen.svg', 'edificios-casa.svg', 'edificios-estadio.svg', 'edificios-fabrica.svg', 'edificios-faro.svg', 'edificios-gasolinera.svg', 'edificios-granja.svg', 'edificios-hospital.svg', 'edificios-hotel.svg', 'edificios-iglesia.svg', 'edificios-lavacoches.svg', 'edificios-tienda.svg', 'edificios-universidad.svg', 'educacion-atomo.svg', 'educacion-birrete.svg', 'educacion-calculadora.svg', 'educacion-clip.svg', 'educacion-compass.svg', 'educacion-cuaderno.svg', 'educacion-lapicero.svg', 'educacion-libro.svg', 'educacion-microscopio.svg', 'educacion-pin.svg', 'educacion-pizarra.svg', 'educacion-quimica.svg', 'educacion-regla.svg', 'educacion-telescopio.svg', 'educacion-tijeras.svg', 'educacion-tribuna.svg', 'energia-bateria.svg', 'energia-estacion-carga.svg', 'energia-molino-viento.svg', 'energia-panel-solar.svg', 'energia-poste.svg', 'general-ajustes.svg', 'general-alerta.svg', 'general-arroba.svg', 'general-ayuda.svg', 'general-cancelar.svg', 'general-circulo.svg', 'general-config.svg', 'general-cono.svg', 'general-corazon.svg', 'general-cronometro.svg', 'general-cuadrado.svg', 'general-cubo.svg', 'general-descargar.svg', 'general-fuente.svg', 'general-info.svg', 'general-linea.svg', 'general-link.svg', 'general-mas.svg', 'general-menos.svg', 'general-menu.svg', 'general-nube.svg', 'general-paraguas.svg', 'general-pin.svg', 'general-poligono.svg', 'general-puntos.svg', 'general-rombo.svg', 'general-triangulo.svg', 'monumento-castillo.svg', 'monumento-catedral.svg', 'monumento-china.svg', 'monumento-coliseo.svg', 'monumento-columna.svg', 'monumento-disneyland.svg', 'monumento-esfinge.svg', 'monumento-estatua.svg', 'monumento-familia.svg', 'monumento-gobierno.svg', 'monumento-india.svg', 'monumento-islam.svg', 'monumento-libertad.svg', 'monumento-madrid.svg', 'monumento-medieval.svg', 'monumento-molino.svg', 'monumento-obelisco.svg', 'monumento-oriental.svg', 'monumento-paris.svg', 'monumento-pisa.svg', 'monumento-puente.svg', 'monumento-stonehenge.svg', 'monumento-templo.svg', 'monumento-torre.svg', 'naturaleza-arboles.svg', 'naturaleza-arbol.svg', 'naturaleza-ballena.svg', 'naturaleza-brote.svg', 'naturaleza-cactus.svg', 'naturaleza-conejo.svg', 'naturaleza-delfin.svg', 'naturaleza-flor.svg', 'naturaleza-gallo.svg', 'naturaleza-hierba.svg', 'naturaleza-hoja.svg', 'naturaleza-hoja2.svg', 'naturaleza-hojas.svg', 'naturaleza-insecto.svg', 'naturaleza-juncos.svg', 'naturaleza-lirio-agua.svg', 'naturaleza-luna.svg', 'naturaleza-medusa.svg', 'naturaleza-nubes.svg', 'naturaleza-olas.svg', 'naturaleza-oveja.svg', 'naturaleza-palmera.svg', 'naturaleza-parque.svg', 'naturaleza-pato.svg', 'naturaleza-pez.svg', 'naturaleza-planta2.svg', 'naturaleza-planta.svg', 'naturaleza-rama.svg', 'naturalez-arbol.svg', 'naturaleza-sol.svg', 'naturaleza-tortuga.svg', 'naturaleza-viento.svg', 'naturalez-pajaro.svg', 'naturalez-rio.svg', 'ocio-ajedrez.svg', 'ocio-barbacoa.svg', 'ocio-cafeteria.svg', 'ocio-cine.svg', 'ocio-cocktail.svg', 'ocio-compras.svg', 'ocio-espectaculo.svg', 'ocio-feria.svg', 'ocio-fotografia.svg', 'ocio-gimnasio.svg', 'ocio-globo.svg', 'ocio-guitarra.svg', 'ocio-helados.svg', 'ocio-natacion.svg', 'ocio-pasteleria.svg', 'ocio-pesca.svg', 'ocio-pintura.svg', 'ocio-piscina.svg', 'ocio-regalo.svg', 'ocio-restaurante.svg', 'ocio-senderismo.svg', 'ocio-spa.svg', 'ocio-submarinismo.svg', 'ocio-yoga.svg', 'profesiones-bombero.svg', 'profesiones-camarero.svg', 'profesiones-carnicero.svg', 'profesiones-carpintero.svg', 'profesiones-conductor.svg', 'profesiones-dentista.svg', 'profesiones-doctor.svg', 'profesiones-enfermero.svg', 'profesiones-granjero.svg', 'profesiones-jardinero.svg', 'profesiones-mecanico.svg', 'profesiones-minero.svg', 'profesiones-obrero.svg', 'profesiones-oficinista.svg', 'profesiones-peluqueria.svg', 'profesiones-pintor2.svg', 'profesiones-pintor.svg', 'profesiones-policia.svg', 'profesiones-soporte.svg', 'salud-alcohol.svg', 'salud-higiene.svg', 'salud-historial.svg', 'salud-inyeccion.svg', 'salud-lavadora.svg', 'salud-maletin.svg', 'salud-mascarilla.svg', 'salud-medicamentos.svg', 'salud-microscopio.svg', 'salud-papel-higienico.svg', 'salud-pauelos.svg', 'salud-pulsaciones.svg', 'salud-receta.svg', 'salud-silla-ruedas.svg', 'salud-termometro.svg', 'salud-tirita.svg', 'salud-virus.svg', 'transporte-ambulacia.svg', 'transporte-avion.svg', 'transporte-bicicleta.svg', 'transporte-bus.svg', 'transporte-camion.svg', 'transporte-caravana.svg', 'transporte-coche.svg', 'transporte-demolicion.svg', 'transporte-grua.svg', 'transporte-helicoptero.svg', 'transporte-moto.svg', 'transporte-taxi.svg', 'transporte-train.svg', 'transporte-vela.svg', 'transporte-yate.svg', 'turismo-area-descanso.svg', 'turismo-bosque.svg', 'turismo-camping.svg', 'turismo-desierto.svg', 'turismo-equipaje.svg', 'turismo-hoguera.svg', 'turismo-mapa.svg', 'turismo-montanya.svg', 'turismo-playa.svg', 'turismo-ruta.svg', 'turismo-seal.svg', 'turismo-teleferico.svg', 'viario-banco.svg', 'viario-barrera.svg', 'viario-basura.svg', 'viario-cono.svg', 'viario-farola.svg', 'viario-letrero.svg', 'viario-parada-bus.svg', 'viario-parking.svg', 'viario-puesto.svg', 'viario-reciclaje.svg', 'viario-semaforo.svg', 'viario-stop.svg'];

    this.icons = svgList;
    this.classIconList = classIconList;
    this.sourceList = sourceList;
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    const html = M.template.compileSync(template, {
      vars: {
        translations: {
          options: getValue('options'),
          size: getValue('size'),
          colour: getValue('colour'),
          thickness: getValue('thickness'),
          style: getValue('style'),
          frameColour: getValue('frameColour'),
          backgroundColour: getValue('backgroundColour'),
          text: getValue('text'),
          font: getValue('font'),
          bold: getValue('bold'),
          italic: getValue('italic'),
          agriculture: getValue('agriculture'),
          comunications: getValue('comunications'),
          sports: getValue('sports'),
          buildings: getValue('buildings'),
          education: getValue('education'),
          energy: getValue('energy'),
          general: getValue('general'),
          monument: getValue('monument'),
          nature: getValue('nature'),
          leisure: getValue('leisure'),
          jobs: getValue('jobs'),
          health: getValue('health'),
          transport: getValue('transport'),
          tourism: getValue('tourism'),
          road: getValue('road'),
          svgexample: getValue('svgexample'),
          addcustomsvg: getValue('addcustomsvg'),
          custom: getValue('custom'),
        },
      },
    });

    const category = html.querySelector('select#style-category');
    if (this.category === null) {
      this.category = category.value;
    }

    const color = html.querySelector('input.color');
    color.value = this.color;
    const cpal = html.querySelector('div.size');
    const destroyPlugin = html.querySelector('button#destroy-plugin');
    const functionDestroyPlugin = function(event) {
      this.plugin.destroyControl();
    };

    const customSize = html.querySelector('div.customSize');
    customSize.children[1].value = this.size;
    const customSizeFunction = () => {
      if (!(customSize.children[1].value > 2)) {
        customSize.children[1].value = 3;
      }
      if (this.size == customSize.children[1].value) {
        return false;
      }
      this.features.forEach((feature) => { feature.set('size', customSize.children[1].value); });
      const elements = html.getElementsByClassName('ppal');
      Array.prototype.forEach.call(elements, (el) => {
        if (el.data == customSize.children[1].value) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });

      let imageStyle;
      if (this.icon === null) {
        imageStyle = new ol.style.Circle({
          radius: Number.parseInt(customSize.children[1].value, 10),
          stroke: new ol.style.Stroke({ color: 'white', width: 2 }),
          fill: new ol.style.Fill({ color: this.color }),
        });
        this.features.forEach((feature) => {
          // eslint-disable-next-line no-param-reassign
          feature.realStyle.image.radius = customSize.children[1].value;
          // eslint-disable-next-line no-param-reassign
          feature.realStyle.scale = false;
        });
      } else {
        let paso2 = this.icon;
        paso2 = paso2.replace('width="' + (this.size * 2) + 'px"', 'width="' + (customSize.children[1].value * 2) + 'px"');
        paso2 = paso2.replace('height="' + (this.size * 2) + 'px"', 'height="' + (customSize.children[1].value * 2) + 'px"');
        const toBTOA = window.btoa(paso2);
        const finalTienda = this.coding + toBTOA;
        imageStyle = new ol.style.Icon({
          src: finalTienda,
        });
        this.icon = paso2;
        this.features.forEach((feature) => {
          feature.set('icon', paso2);
          // eslint-disable-next-line no-param-reassign
          feature.realStyle.scale = true;
        });
      }
      this.features.forEach((feature) => { feature.getStyle().setImage(imageStyle); feature.changed(); });
      this.plugin.plugin.changeSquare();
      this.size = customSize.children[1].value;
    };
    customSize.children[1].addEventListener('keydown', (kdwn) => {
      if (kdwn.key === 'Enter') {
        customSizeFunction();
      } else if (kdwn.key.length === 1 && !(/[0-9]/.test(kdwn.key) || kdwn.altKey || kdwn.ctrlKey || kdwn.metaKey || kdwn.shiftKey)) kdwn.preventDefault();
    });
    customSize.children[1].addEventListener('paste', (pst) => {
      if (/^\d*[1-9]\d*$/.test((pst.clipboardData || window.clipboardData).getData('text'))) {
        return false;
      }
      pst.preventDefault();
      return true;
    });
    customSize.children[1].addEventListener('input', (inp) => {
      if (inp.inputType === 'insertReplacementText' || inp.inputType === undefined) { // Chrome bug with arrows, added undefined.
        clearTimeout(this.timerReplacement);
        this.timerReplacement = setTimeout(customSizeFunction.bind(this), 300);
      } else if (inp.inputType === 'insertFromPaste') customSizeFunction();
    });
    customSize.children[1].addEventListener('blur', customSizeFunction);
    // customSize.children[2].addEventListener('click', customSizeFunction);

    destroyPlugin.addEventListener('click', functionDestroyPlugin.bind(this));

    for (let i = 3; i <= 24; i *= 2) {
      const p = document.createElement('div');
      p.title = i;
      p.classList.add('ppal');
      p.data = i;
      p.style.backgroundImage = ImageCircle;
      cpal.append(p);
      const sizeIcon = document.createElement('IMG');
      sizeIcon.style.width = (((21 + i) + (8 * (i / 6))) * 0.75) + 'px';
      // sizeIcon.style.marginTop = 4 + 'px';
      p.append(sizeIcon);
      let img = p.style.backgroundImage;
      if (img === 'none') {
        img = null;
      } else {
        img = img.replace(/^url\((.+)\)/, '$1').replace(/'/g, '');
      }
      sizeIcon.src = ImageCircle;
      p.style.backgroundImage = 'none';

      if (this.size === p.data) {
        p.classList.add('active');
      }
      p.addEventListener('click', () => { // ChangeSize por cada p
        this.features.forEach((feature) => { feature.set('size', p.data); });
        const elements = html.getElementsByClassName('ppal');
        Array.prototype.forEach.call(elements, (el) => {
          el.classList.remove('active');
        });
        p.classList.add('active');
        let imageStyle;
        if (this.icon === null) {
          imageStyle = new ol.style.Circle({
            radius: p.data,
            stroke: new ol.style.Stroke({ color: 'white', width: 2 }),
            fill: new ol.style.Fill({ color: this.color }),
          });
          this.features.forEach((feature) => {
            // eslint-disable-next-line no-param-reassign
            feature.realStyle.image.radius = p.data;
            // eslint-disable-next-line no-param-reassign
            feature.realStyle.scale = false;
          });
        } else {
          let paso2 = this.icon;
          paso2 = paso2.replace('width="' + (this.size * 2) + 'px"', 'width="' + (p.data * 2) + 'px"');
          paso2 = paso2.replace('height="' + (this.size * 2) + 'px"', 'height="' + (p.data * 2) + 'px"');
          const toBTOA = window.btoa(paso2);
          const finalTienda = this.coding + toBTOA;
          imageStyle = new ol.style.Icon({
            src: finalTienda,
          });
          this.icon = paso2;
          this.features.forEach((feature) => {
            feature.set('icon', paso2);
            // eslint-disable-next-line no-param-reassign
            feature.realStyle.scale = true;
          });
        }
        this.features.forEach((feature) => { feature.getStyle().setImage(imageStyle); feature.changed(); });
        this.plugin.plugin.changeSquare();
        this.size = p.data;
        customSize.children[1].value = p.data;
      });
    }

    const cpal2 = html.querySelector('div.style');
    cpal2.classList.add('icon-palette');
    const iconList = document.createElement('div');
    iconList.classList.add('ipal-list');
    cpal2.append(iconList);

    const changeColor = function(event) {
      let imageStyle;
      if (this.icon === null) {
        imageStyle = new ol.style.Circle({
          radius: this.size,
          stroke: new ol.style.Stroke({ color: 'white', width: 2 }),
          fill: new ol.style.Fill({ color: color.value }),
        });
        this.features.forEach((feature) => {
          // eslint-disable-next-line no-param-reassign
          feature.realStyle.image.radius = this.size;
          // eslint-disable-next-line no-param-reassign
          feature.realStyle.scale = false;
        });
      } else {
        let paso2 = this.icon;
        /* const colorString = '<path fill="' + this.color + '"';
        const re = new RegExp(colorString, 'g');
        const polygonString = '<polygon fill="' + this.color + '"';
        const rd = new RegExp(polygonString, 'g');
        const rectString = '<rect fill="' + this.color + '"';
        const rect = new RegExp(rectString, 'g');
        paso2 = paso2.replace(re, '<path fill="' + color.value + '"'); */
        paso2 = paso2.replace(/<path([^>]*)>/ig, (match) => {
          if (match.match(/fill=['"]([^"^']*)["']/ig)) {
            return match.replace(/fill=['"]([^"^']*)["']/ig, 'fill="' + color.value + '"');
          }
          return match.replace(/<path/ig, '<path fill="' + color.value + '"');
        });
        // paso2 = paso2.replace(rd, '<polygon fill="' + color.value + '"');
        paso2 = paso2.replace(/<polygon([^>]*)>/ig, (match) => {
          if (match.match(/fill=['"]([^"^']*)["']/ig)) {
            return match.replace(/fill=['"]([^"^']*)["']/ig, 'fill="' + color.value + '"');
          }
          return match.replace(/<polygon/ig, '<polygon fill="' + color.value + '"');
        });
        // paso2 = paso2.replace(rect, '<rect fill="' + color.value + '"');
        paso2 = paso2.replace(/<rect([^>]*)>/ig, (match) => {
          if (match.match(/fill=['"]([^"^']*)["']/ig)) {
            return match.replace(/fill=['"]([^"^']*)["']/ig, 'fill="' + color.value + '"');
          }
          return match.replace(/<rect/ig, '<rect fill="' + color.value + '"');
        });
        const toBTOA = window.btoa(paso2);
        const finalTienda = this.coding + toBTOA;
        imageStyle = new ol.style.Icon({
          src: finalTienda,
        });
        this.features.forEach((feature) => {
          feature.set('icon', paso2);
          // eslint-disable-next-line no-param-reassign
          feature.realStyle.scale = true;
        });
        this.icon = paso2;
      }
      this.features.forEach((feature) => { feature.getStyle().setImage(imageStyle); feature.set('color', color.value); feature.changed(); });
      this.color = color.value;
    };

    if (!window.memoryCustomSVG) {
      window.memoryCustomSVG = [];
    }
    const changeCategory = function(event) {
      this.category = category.value;
      iconList.innerHTML = '';

      if (this.category === 'personalizado') {
        const innerMemoryIcons = window.memoryCustomSVG;
        for (let i = 0; i < innerMemoryIcons.length; i += 1) {
          const p = document.createElement('div');
          p.classList.add('ipal');
          p.data = window.atob(innerMemoryIcons[i].data.substr(36, innerMemoryIcons[i].data.length - 39));// Similar class name fix
          p.innerHTML = innerMemoryIcons[i].data;
          iconList.append(p);
          p.addEventListener('click', () => {
            this.setSVG(p.data);
          });
        }
      } else {
        const innerFilteredIcons = this.icons.filter((icon) => {
          return icon.indexOf(this.category) > -1 || (this.category === 'general' && icon.indexOf('cartografia') > -1);
        });

        const innerFilteredIconList = this.classIconList.filter((icon) => {
          let res = false;
          if (this.category === 'general' && icon === 'CirculoSVG') {
            res = true;
          } else if (icon !== 'CirculoSVG') {
            const text = window.atob(icon.split('base64,')[1]);
            res = text.indexOf(this.category) > -1;
          }

          return res;
        });

        const innerFilteredSourceList = this.sourceList.filter((icon) => {
          return icon.indexOf(this.category) > -1 || (this.category === 'general' && icon === 'CirculoSVG');
        });

        for (let i = 0; i < innerFilteredIcons.length; i += 1) {
          const p = document.createElement('div');
          p.classList.add('ipal');
          p.classList.add(innerFilteredIcons[i]);
          p.data = innerFilteredIconList[i];
          p.sourceData = innerFilteredSourceList[i];
          iconList.append(p);
          p.addEventListener('click', () => {
            this.setIcon(p.data, p.sourceData);
          });
        }
      }
    };
    if (window.memoryCustomSVG.length > 0) {
      category.value = 'personalizado';
    }
    changeCategory.bind(this, category)();

    const inputSVG = html.querySelector('div.style-col-1 > button.editiontools-subir > input#file-upload');
    inputSVG.addEventListener('change', () => {
      inputSVG.files[0].text().then((res) => {
        const commentCleared = this.fixesForSVG(res);// fix for base64, openlayer and legend
        if (!this.setSVG(commentCleared)) {
          M.exception('ERROR: SVG contiene atributo "fill" sobrante'); // "fill" sobrante en una de estos elementos [path, polygon, rect]
        } else {
          if (!window.memoryCustomSVG.find(m => m.namesize === (inputSVG.files[0].name + inputSVG.files[0].size))) {
            const preparedSVGImage = '<img src="data:image/svg+xml;base64,' + window.btoa(commentCleared) + '"/>';// Similar class name fix
            window.memoryCustomSVG.push({ namesize: inputSVG.files[0].name + inputSVG.files[0].size, data: preparedSVGImage });
          }
          category.value = 'personalizado';
          changeCategory.bind(this, category)();
        }
      });
    });

    color.addEventListener('change', changeColor.bind(this, color));
    category.addEventListener('change', changeCategory.bind(this, category));
    setTimeout(() => {
      const elem = document.querySelector('.m-panel.m-tools-styleTools');
      if (elem !== null) {
        const draggable = new Draggabilly(elem, {
          containment: '.m-mapea-container',
          handle: '#styleToolsHTML > div > div.title',
        });

        draggable.enable();
      }
    }, 300);

    return html;
  }

  r1(s) { // limpiar Accentos
    const l = s.length;
    const a = new Array(l);
    for (let i = 0; i != l; i += 1) { a[i] = DC[s.charCodeAt(i)] || s.charCodeAt(i); }
    return String.fromCharCode.apply(null, a);
  }

  setSVG(text) {
    let tempSVG = text;
    if (tempSVG.match(/<svg[^>]*width="[0-9]+(\.\d*)?(px)?"[^>]*>/g)) {
      tempSVG = tempSVG.replace(/width="[0-9]+(\.\d*)?(px)?"/, 'width="' + (this.size * 2) + 'px"');
      tempSVG = tempSVG.replace(/height="[0-9]+(\.\d*)?(px)?"/, 'height="' + (this.size * 2) + 'px"');
    } else {
      tempSVG = tempSVG.replace('<svg ', '<svg width="' + (this.size * 2) + 'px" height="' + (this.size * 2) + 'px" ');
    }
    const preparedSVG = tempSVG;
    // .replace(/<path/g, '<path fill="' + this.color + '"')
    // .replace(/<polygon/g, '<polygon fill="' + this.color + '"')
    // .replace(/<rect/g, '<rect fill="' + this.color + '"');

    if (!preparedSVG.match(/fill=[^>]+fill=/)) {
      const data = window.btoa(preparedSVG);
      this.features.forEach((feature, ind) => {
        feature.getStyle().setImage(new ol.style.Icon({
          src: this.coding + data,
          id: data,
        }));
        this.features[ind].realStyle.scale = true;
        // feature.set('sourceData', sourceData);
        feature.set('color', this.color);
        feature.set('size', this.size);
        feature.set('icon', preparedSVG);
        feature.changed();
      });
      this.icon = preparedSVG;
      return true;// Funciona bien
    }
    return false;// En caso de error
  }

  fixesForSVG(svgToFix) {
    let result = svgToFix.slice(svgToFix.indexOf('<svg'));// Removes everything before <svg (maybe could be referenced back instead all &)
    result = this.r1(svgToFix);// Eliminar valores no transformables de base64
    result = result.replaceAll(/<metadata>(\s|.)*?<\/metadata>/g, '');// solución para abrigo.svg
    result = result.replaceAll(/clip-path=".*?"/g, '');// solución para arbol-singular.svg
    result = result.replace(/<svg(\s|.)*?>/, (r) => { return r.replace(/x="0+(px)?"/, 'x="40"').replace(/y="0+(px)?"/, 'y="40"'); });// solución base64 "0px" error.
    return result;
  }

  setIcon(data, sourceData) {
    if (data != 'CirculoSVG') {
      const paso1 = data.replace(this.coding, '');
      const toATOB = window.atob(paso1);
      let paso2 = toATOB.toString();
      paso2 = paso2.replace(/<path/g, '<path fill="' + this.color + '"');
      paso2 = paso2.replace(/<polygon/g, '<polygon fill="' + this.color + '"');
      paso2 = paso2.replace(/<rect/g, '<rect fill="' + this.color + '"');
      paso2 = paso2.replace(/width="10px"/g, 'width="' + (this.size * 2) + 'px"');
      paso2 = paso2.replace(/height="10px"/g, 'height="' + (this.size * 2) + 'px"');
      const toBTOA = window.btoa(paso2);
      const finalTienda = this.coding + toBTOA;
      // if (this.feature.getStyle().getImage() === null) {
      this.features.forEach((feature, ind) => {
        feature.getStyle().setImage(new ol.style.Icon({
          src: finalTienda,
          id: data,
        }));
        this.features[ind].realStyle.scale = true;
        feature.set('sourceData', sourceData);
        feature.set('color', this.color);
        feature.set('size', this.size);
        feature.set('icon', paso2);
        feature.changed();
      });

      this.icon = paso2;
    } else {
      const imageStyle = new ol.style.Circle({
        radius: this.size,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: this.color,
        }),
      });
      this.features.forEach((feature, ind) => {
        feature.getStyle().setImage(imageStyle);
        this.features[ind].realStyle.image.radius = this.size;
        this.features[ind].realStyle.scale = false;
        feature.set('icon', null);
        feature.changed();
      });
      this.icon = null;
    }
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof PointStyle;
  }

  // Add your own functions
}
